document.addEventListener("DOMContentLoaded", function () {

    console.log("========== PRICE BREAKUP INIT ==========");

    const jsonElement = document.getElementById("PriceBreakupData");

    if (!jsonElement) {
        console.error("❌ PriceBreakupData JSON not found");
        return;
    }

    const breakupData = JSON.parse(jsonElement.textContent);

    // Function to update breakup
function formatMoney(value) {
    return new Intl.NumberFormat("en-IN", {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
    }).format(value);
}

function updatePriceBreakup(variantId) {

    const variant = breakupData.find(item => Number(item.id) === Number(variantId));

    if (!variant) {
        console.warn("Variant not found");
        return;
    }

    const goldWeight = Number(variant.gold_weight);
    const goldRate = Number(variant.gold_rate);
    const diamondWeight = Number(variant.diamond_weight);
    const diamondRate = Number(variant.diamond_rate);

const diamondValue =
    diamondWeight * diamondRate;
    const makingCharge = Number(variant.making_charge);
    const gst = Number(variant.gst);

    const goldValue = goldWeight * goldRate;

    const subtotal =
        goldValue +
        diamondValue +
        makingCharge;

    const livePrice = Number(variant.price);

    let discount = 0;

    if (subtotal > livePrice) {
        discount = subtotal - livePrice;
    }

    console.log("Variant", variant);

    // Gold
    document.getElementById("pbGoldTitle").innerHTML =
        `${variant.option1} Gold`;

    document.getElementById("pbGoldWeight").innerHTML =
        `${goldWeight} g`;

    document.getElementById("pbGoldRate").innerHTML =
        `₹${formatMoney(goldRate)}/g`;

    document.getElementById("pbGoldValue").innerHTML =
        `₹${formatMoney(goldValue)}`;

    // Diamond
    document.getElementById("pbDiamondTitle").innerHTML =
        `Lab Diamond (${variant.option2.toUpperCase()})`;

    document.getElementById("pbDiamondWeight").innerHTML =
        `${diamondWeight} Ct`;
        document.getElementById("pbDiamondRate").innerHTML =
    `₹${formatMoney(diamondRate)}/Ct`;

    document.getElementById("pbDiamondValue").innerHTML =
        `₹${formatMoney(diamondValue)}`;

    // Making
    document.getElementById("pbMakingCharge").innerHTML =
        `₹${formatMoney(makingCharge)}`;

    // Subtotal
    document.getElementById("pbSubtotal").innerHTML =
        `<strong>₹${formatMoney(subtotal)}</strong>`;

    // Total
    document.getElementById("pbTotal").innerHTML =
        `<strong>₹${formatMoney(livePrice)}</strong>`;

    // Discount
    const discountRow = document.getElementById("pbDiscountRow");

    if (discount > 0) {

        discountRow.style.display = "";

        document.getElementById("pbDiscount").innerHTML =
            `- ₹${formatMoney(discount)}`;

    } else {

        discountRow.style.display = "none";

    }

    // GST
    const gstRow = document.getElementById("pbGstRow");

    if (gstRow) {

        if (gst > 0) {
            gstRow.style.display = "";
            document.getElementById("pbGST").innerHTML =
                `₹${formatMoney(gst)}`;
        } else {
            gstRow.style.display = "none";
        }

    }

}

    // Initial page load
    const masterSelect = document.querySelector('select[name="id"]');
    if (masterSelect) {
        updatePriceBreakup(masterSelect.value);
        masterSelect.addEventListener("change", function () {
            updatePriceBreakup(this.value);
        });

    } else {
        console.warn("⚠️ Master Select Not Found");
    }

    // Listen on visible dropdowns
    const optionSelectors = document.querySelectorAll(".single-option-selector");
    console.log("Visible Selectors :", optionSelectors.length);
    optionSelectors.forEach((select, index) => {
        select.addEventListener("change", function () {
            setTimeout(() => {
                const currentVariant =
                    document.querySelector('select[name="id"]').value;
                updatePriceBreakup(currentVariant);
            }, 100);

        });

    });

});